import axios from "axios";
import React from "react";

interface IArea {
  id: number;
  name: string;
}

export default function useAreas(): [Map<number, string>, boolean] {
  const [areas, setAreas] = React.useState<Map<number, string>>(new Map());
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<IArea[]>("/areas/")
      .then((response) => {
        setAreas(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, []);

  return [areas, loading];
}
